import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { CurrencyService } from '../proxy/controlling/controllers/currency.service';

FieldBuilder.setNamespace('Controlling');

export const EXCHANGERATE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .date('documentDate', 'Entity.ExchangeRate.DocumentDate')
    .required()
    .build(),
  FieldBuilder
    .number('value', 'Entity.ExchangeRate.Value')
    .required()
    .decimal(2,8)
    .build(),
  FieldBuilder
    .foreignKey('currencyId', 'Entity.Currency', CurrencyService)
    .required()
    .displayFromNested('currency.name')
    .sortBy('currency.name')
    .build(),
];

export const EXCHANGERATE_CONFIG = {
  entityName: 'ExchangeRate',
  localizationKey: 'Controlling::Entity.ExchangeRate',
  fields: EXCHANGERATE_FIELDS,
  permission: 'ControllingSap.ExchangeRates',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
